import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=4381fec2&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"
import style0 from "./manage.vue?vue&type=style&index=0&id=4381fec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381fec2",
  null
  
)

export default component.exports